import { Device } from 'components/Device'
import Hamburger from 'components/Icons/Hamburguer'
import { useAccessibility } from 'context/hooks/useAccessibility'
import { useEffect, useRef, useState } from 'react'

import './styles.scss'

function Accessibility() {
  const [showLibras, setShowLibras] = useState(false)

  const [hamburgerIsOpen, setHamburgerIsOpen] = useState(false)

  const currentWidth = Device.useDevice().currentWidth()

  const refAreaNav = useRef<HTMLDivElement>(null)

  const refAreaLibras = useRef<HTMLButtonElement>(null)

  const {
    toogleContrast,
    addLengthText,
    removeLengthText,
    resetLengthText,
    lengthText,
    contrastIsSelected,
  } = useAccessibility()

  useEffect(() => {
    setHamburgerIsOpen(false)
  }, [currentWidth > 1200])

  function handleShowLibras() {
    setShowLibras((showLibras) => !showLibras)
  }

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const clickAreaNav: boolean =
        refAreaNav.current?.contains(event.target as Node) !== undefined
      const clickAreaLibras: boolean =
        refAreaLibras.current?.contains(event.target as Node) !== undefined

      if (!clickAreaNav && !clickAreaLibras) {
        setShowLibras(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [refAreaNav])

  return (
    <header className="containerAcessibility">
      <section className="containerAcessibility-content">
        {currentWidth >= 1200 ? (
          <div className="containerAcessibility-content__infosGov">
            <a
              href="http://www.ceara.gov.br/"
              target="_blank"
              className="containerAcessibility-content__infosGov--item"
              rel="noreferrer"
            >
              Portal do Governo
            </a>
            <span className="containerAcessibility-content__infosGov--divider"></span>
            <a
              href="https://cearatransparente.ce.gov.br/"
              target="_blank"
              className="containerAcessibility-content__infosGov--item"
              rel="noreferrer"
            >
              Ceará Transparente
            </a>
            <span className="containerAcessibility-content__infosGov--divider"></span>
            <a
              href="https://cearatransparente.ce.gov.br/portal-da-transparencia/ouvidoria?locale=pt-BR"
              target="_blank"
              className="containerAcessibility-content__infosGov--item"
              rel="noreferrer"
            >
              Ouvidoria
            </a>
            <span className="containerAcessibility-content__infosGov--divider"></span>
            <a
              href="https://www.ceara.gov.br/acesso-a-informacao/"
              target="_blank"
              className="containerAcessibility-content__infosGov--item"
              rel="noreferrer"
            >
              Acesso à Informação
            </a>
          </div>
        ) : (
          <div
            className={`containerAcessibility-content__hamburguer ${
              hamburgerIsOpen ? 'open' : ''
            }`}
          >
            <button
              onClick={() => {
                setHamburgerIsOpen(!hamburgerIsOpen)
              }}
              className="containerAcessibility-content__hamburguer--button"
            >
              <Hamburger isOpen={hamburgerIsOpen} />
            </button>

            {hamburgerIsOpen && (
              <div className="containerAcessibility-content__hamburguer--infosGov">
                <a
                  href="http://www.ceara.gov.br/"
                  target="_blank"
                  className="containerAcessibility-content__hamburguer--infosGov__item"
                  rel="noreferrer"
                >
                  Portal do Governo
                </a>
                <span className="containerAcessibility-content__hamburguer--infosGov__divider"></span>
                <a
                  href="https://cearatransparente.ce.gov.br/"
                  target="_blank"
                  className="containerAcessibility-content__hamburguer--infosGov__item"
                  rel="noreferrer"
                >
                  Ceará Transparente
                </a>
                <span className="containerAcessibility-content__hamburguer--infosGov__divider"></span>
                <a
                  href="https://cearatransparente.ce.gov.br/portal-da-transparencia/ouvidoria?locale=pt-BR"
                  target="_blank"
                  className="containerAcessibility-content__hamburguer--infosGov__item"
                  rel="noreferrer"
                >
                  Ouvidoria
                </a>
                <span className="containerAcessibility-content__hamburguer--infosGov__divider"></span>
                <a
                  href="https://www.ceara.gov.br/acesso-a-informacao/"
                  target="_blank"
                  className="containerAcessibility-content__hamburguer--infosGov__item"
                  rel="noreferrer"
                >
                  Acesso à Informação
                </a>
              </div>
            )}
          </div>
        )}
        <div className="containerAcessibility-content__acessibilityControls">
          <span>Acessibilidade</span>
          <button
            aria-label="Fonte normal"
            id="normalFont"
            disabled={lengthText === 60}
            onClick={() => {
              resetLengthText()
            }}
          ></button>
          <button
            aria-label="Diminuir fonte"
            id="decreaseFont"
            disabled={lengthText === 60}
            onClick={() => {
              removeLengthText()
            }}
          ></button>
          <button
            aria-label="Aumentar fonte"
            id="increaseFont"
            disabled={lengthText === 80}
            onClick={() => {
              addLengthText()
            }}
          ></button>
          <button
            aria-label="Iniciar V-Libras"
            id="startVLibras"
            onClick={handleShowLibras}
            ref={refAreaLibras}
          ></button>
          <button
            aria-label="Trocar tema"
            onClick={() => {
              toogleContrast()
            }}
            id="changeTheme"
          ></button>
          {showLibras && (
            <div
              ref={refAreaNav}
              className={
                contrastIsSelected
                  ? 'accessibility__container-link-vlibras vlibras-contrast'
                  : 'accessibility__container-link-vlibras'
              }
            >
              <img
                src="//barra.brasil.gov.br/imagens/vlibras.gif"
                alt="Libras"
                data-src="//barra.brasil.gov.br/imagens/vlibras.gif"
              />
              &nbsp;
              <br />O conteúdo desse portal pode ser acessível em Libras usando
              o <a href="http://www.vlibras.gov.br">VLibras</a>.
            </div>
          )}
        </div>
      </section>
    </header>
  )
}

export default Accessibility
